export default {
  toasts: {
    success: 'Karta podarunkowa została pomyślnie zrealizowana.',
    error: 'Realizacja karty podarunkowej nie powiodła się.',
  },
  title: 'Zrealizuj kartę podarunkową',
  subtitle: 'Wprowadź kod karty podarunkowej i kwotę do odliczenia z rachunku klienta.',
  form: {
    amount: {
      label: 'Kwota do realizacji',
    },
    code: {
      label: 'Kod karty podarunkowej',
    },
  },
  buttons: {
    redeem: 'Zrealizuj',
    cancel: 'Anuluj',
  },
};
